<template>
  <div>
    <navigation/>
    <div class="pale-bgcolor">
      <div class="bright-contain">
        <h2 class="ty_title" style="height:auto;line-height:60px;">
          {{ siteBaseInfo.companyName }}
          <!--  <div class="bdsharebuttonbox  ty_info-share">
              <a href="#" class="bds_more" data-cmd="more">分享到：</a>
              <a href="#" class="bds_weixin" data-cmd="weixin" title="分享到微信">微信</a>
              <a href="#" class="bds_tsina" data-cmd="tsina" title="分享到新浪微博">新浪微博</a>
              <a href="#" class="bds_qzone" data-cmd="qzone" title="分享到QQ空间">QQ空间</a>
            </div>-->
        </h2>
        <!-- 亮照通过 -->
        <div v-if="siteBaseInfo.applyStatus == 1" class="time_show_contain">恭喜您！亮照已经审核通过，请按照
          <router-link :to="{path:'/notebook'}" target="_blank">使用说明</router-link>
          完成亮照使用;
        </div>
        <!-- 复审通过通过 -->
        <div v-if="siteBaseInfo.applyStatus == 5" class="time_show_contain">恭喜您！亮照复审通过，需在亮照公示7天，无人异议投诉方可亮照通过。已公示
          <div id="time_show"></div>
          7天之内自动下架公示。若有人异议投诉则在60天之内处理;
        </div>

        <div class="ty_table">
          <div class="ty_table_title">企业基本信息</div>
          <table cellpadding="0" cellspacing="0" border="0">
            <tbody>
            <tr>
              <td class="ty1">企业名称</td>
              <td class="ty2">{{ siteBaseInfo.companyName }}</td>
              <td class="ty3">统一社会信用代码</td>
              <td class="ty4">{{ siteBaseInfo.companyNumber }}</td>
            </tr>
            <tr>
              <td class="ty1">法定代表人</td>
              <td class="ty2">{{ siteBaseInfo.companyLegalPerson }}</td>
              <td class="ty3">注册资本</td>
              <td class="ty4">{{ siteBaseInfo.companyRegisterMoney }}</td>
            </tr>
            <tr>
              <td class="ty1">类型</td>
              <td class="ty2">
                {{ siteBaseInfo.companyTypeStr }}
              </td>
              <td class="ty3">住址</td>
              <td class="ty4">{{ siteBaseInfo.address }}</td>
            </tr>
            <tr>
              <td class="ty1">成立日期</td>
              <td class="ty2">{{ siteBaseInfo.companyCreateTime }}</td>
              <td class="ty3">营业期限</td>
              <td class="ty4">{{ siteBaseInfo.operateTimeStart }}</td>
            </tr>
            <tr>
              <td class="ty1">登记机关</td>
              <td colspan="3" class="ty_right">{{ siteBaseInfo.registerOffice }}</td>
            </tr>
            <tr>
              <td class="ty1">经营范围</td>
              <td colspan="3" class="ty_right">{{ siteBaseInfo.operateScope }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="ty_table ty_bottom">
          <div class="ty_table_title">备案信息</div>
          <table cellpadding="0" cellspacing="0" border="0">
            <tbody>
            <tr>
              <td class="ty1">网站名称</td>
              <td class="ty2">{{ siteBaseInfo.siteName }}</td>
              <td class="ty3">域名</td>
              <td class="ty4">{{ siteBaseInfo.siteDomain }}</td>
            </tr>
            <tr>
              <td class="ty1">网站说明</td>
              <td class="ty2">{{ siteBaseInfo.siteDescription }}</td>
              <td class="ty3">网站类型</td>
              <td class="ty4">{{ siteBaseInfo.siteTypeStr }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navigation from './navigation'
import utilAPi from "../assets/js/utils";

export default {
  name: 'detailSite',
  components: {
    'navigation': navigation
  },
  data: function () {
    return {
      siteBaseInfo: {
        auditorTime: null,
        verCode: null,
        siteBaseId: null,
        companyName: null,
        companyLegalPerson: null,
        companyNumber: null,
        companyType: null,
        companyRegisterMoney: null,
        companyCreateTime: null,
        registerOffice: null,
        operateTimeStart: null,
        operateTimeEnd: null,
        address: null,
        operateScope: null,
        siteType: null,
        siteDomain: null,
        siteName: null,
        siteDescription: null,
        orgId: null,
        applyStatus: null,
        description: null,
        isOwned: null,
        ownerOrg: null,
        ownerOrgCode: null,
        dealType: null,
        applyPhone: null,
        applyName: null,
        clientUserId: null,
        applyEmail: null
      }
    }
  },
  created() {
    this.getSiteBaseInfo(this.$route.params.siteBaseId)
  }, methods: {
    showTime(time, id_html) {
      let _self = this
      this.timer = setInterval(() => {
        _self.showCountDown(time, id_html)
      }, 1000);
    },
    showCountDown(time, id_html) {
      var date1 = new Date();
      var timelong = date1.getTime() - this.parsetDate(time);
      var d = parseInt(timelong / (1000 * 60 * 60 * 24), 10);
      var h = parseInt(((timelong / 3600000) - (24 * d)), 10);
      var m = parseInt(timelong % 3600000 / 60000, 10);
      var s = parseInt(timelong % 60000 / 1000);
      $("#" + id_html).html(d + "天" + h + "小时" + m + "分" + s + "秒");
    },
    parsetDate(str_date) {
      str_date = str_date.replace(/-/g, "/");
      var date = new Date(str_date);
      return date.getTime();
    },
    getSiteBaseInfo(siteBaseId) {
      let _self = this
      _self.axios.get(
        _self.api.getSiteBaseInfoById + siteBaseId,
      ).then(res => {
        if (res.data.code === 10001) {
          this.toIndex()
        }
        this.siteBaseInfo = res.data.obj
        if (this.siteBaseInfo.applyStatus === 5) {
          this.showTime(this.siteBaseInfo.auditorTime, 'time_show')
        }
      }).catch(err => {
        this.$message.error('网络请求异常!')
      })
    },
    toIndex() {
      this.$router.push({
        path: '/index'
      })
    }
  }
}
</script>

<style>
@import '../assets/css/newStyle.css';
@import '../assets/css/aicUser.css';
@import '../assets/css/bright.css';

.time_show_contain {
  font-size: 14px;
  color: #666;
  text-align: right;
  padding-right: 25px;
}

.time_show_contain #time_show {
  display: inline-block;
  color: #00BFFF;
  font-weight: bold;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/detailSite.vue